import { dateFormatMap } from '@op/constants';
import { formatTime, toPercent } from '../../render-helper';

export default function (name: string) {
  return (params: any) => {
    const { dateType } = params;
    return [
      {
        renderHelper: [formatTime(dateFormatMap[dateType])],
        header: 'Date',
        render: 'time',
      },
      {
        header: name,
        render: 'review',
      },
      {
        header: `${name} Positive%`,
        render: 'score',
        numFmt: '0%',
      },
    ];
  };
}
